import { Controller } from 'stimulus';
import fitty from 'fitty';

class FitTextController extends Controller {
  connect() {
    let minFontSize;
    let maxFontSize;

    if (this.data.has('min-font-size') && this.data.has('max-font-size')) {
      minFontSize = this.data.get('min-font-size');
      maxFontSize = this.data.get('max-font-size');
    } else {
      const elementWidth = this.element.offsetWidth;
      minFontSize = elementWidth > 250 ? 46 : 16;
      maxFontSize = elementWidth > 250 ? 80 : 32;
    }

    fitty(this.element, {
      minSize: minFontSize,
      maxSize: maxFontSize,
    });
  }
}

export default FitTextController;
